var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9047 10.1143C16.0309 6.85112 8.8125 11.0985 8.8125 17.8179V76.1818C8.8125 82.9013 16.0309 87.1485 21.9047 83.8855L74.4323 54.7032C80.4761 51.3459 80.4761 42.654 74.4323 39.2962L21.9047 10.1143Z",
    fill: "#71D0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6793 34.4334L21.9048 10.1143C17.2925 7.55194 11.851 9.62052 9.72656 13.8806L11.6313 15.7853L11.6759 15.8291L46.4152 49.1208C47.5514 50.2096 49.3436 50.2096 50.4799 49.1208L62.741 37.3707L62.7856 37.327L65.6793 34.4334Z",
    fill: "#A2D471"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6793 59.5666L62.7856 56.673L62.741 56.6291L50.4799 44.8791C49.3436 43.7903 47.5514 43.7903 46.4152 44.8791L11.6759 78.1708L11.6313 78.2147L9.72656 80.1193C11.851 84.3795 17.2925 86.4479 21.9048 83.8856L65.6793 59.5666Z",
    fill: "#F17171"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3366 31.4653L58.6516 33.1505L46.4132 44.8789C45.8351 45.4328 45.5081 46.1989 45.5081 46.9998C45.5081 47.8004 45.8351 48.5665 46.4132 49.1207L58.6516 60.8491L60.3366 62.5341L74.4322 54.7031C80.4761 51.3457 80.4761 42.6539 74.4322 39.2961L60.3366 31.4653Z",
    fill: "#FFC44D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.b76084e002d077b5b02cd1713e1efea9.svg";
export { ForwardRef as ReactComponent };